import React from 'react';
import { TextField, Typography } from '@mui/material';
import { useFeatureTheme } from '../../../../../theme/hooks/useFeatureTheme';
import FieldSettingsPanel from './FieldSettingsPanel';

export default function FieldHotRecordSettings({
  value,
  error,
  helperText,
  onChange,
}) {
  const { semantic, typographyStyles } = useFeatureTheme();

  return (
    <FieldSettingsPanel title="Hot record criteria">
      <Typography
        variant="body2"
        sx={{
          ...typographyStyles.caption,
          color: semantic.text.secondary,
          mb: 1.5,
        }}
      >
        Define when a record should be marked hot based on this field.
      </Typography>
      <TextField
        label="Hot record criteria"
        size="small"
        fullWidth
        multiline
        minRows={2}
        value={value || ''}
        onChange={(event) => onChange(event.target.value)}
        error={Boolean(error)}
        helperText={helperText || error}
        placeholder="Enter criteria for hot records"
      />
    </FieldSettingsPanel>
  );
}
